<template>
  <div  @click.stop="close()" v-show="showAlert" class="alert">
		<div class="content">
			<div class="border_div">
				点赞成功！
			</div>
		</div>

  </div>
</template>


<script>
import { mapState } from 'vuex'
export default {
  name: 'alert',
  data(){
	  return {

	  }
  },
  props : ['test'],
  methods: {
  	close() {
  		this.$store.commit('setShowAlert',false);
  	}
  },
  updated(){

  },
  computed: mapState([
  			  'showAlert'
  ]),
  created(){

	// this.show = this.store.state.showQrCode ;
  },
  components: {

  }
}
</script>

<style>
	.alert{
		 width: 100%;
		 height: 100%;
		 position: fixed;
		 top: 0px;
		 left: 0px;
		 z-index: 999;
		 background-color: rgb(0 0 0 / 42%);

	}

	.alert .content{
		width: 6.633928rem;
		height: 3.35rem;
		background:#fff;
		border-radius: 6px;
		box-sizing: border-box;
		position: fixed;
		top: 50%;
		left: 50%;
		margin-top: -2.044642rem;
		margin-left: -3.227678rem;
		display:flex;
		justify-content: center;
		align-items: center;

	}
	.content>.border_div{
		width:95%;
		height:2.8rem;
		border:1px dashed #1656DA;
		text-align: center;
		line-height: 2.8rem;
		font-size:0.6rem;
		font-weight: bold;
		border-radius:6px;
	}

	.alert .close{
		    width: 0.303571rem;
		    margin-top: 0.205357rem;
		    margin-left: auto;
		    margin-right: 0.321428rem;
			display: block;
	}

</style>
